// src/features/boe/components/programs/Program0500.jsx
import React from "react";
import { ProgramBudget } from "../../../../budget/model/program/ProgramBudget.jsx";

export const PROGRAM_0500_CONFIG = {
  fullName: "MATHEMATICS",
  docId: "0500",

  fieldDefs: [
    // POSITIONS (FTE)
    {
      key: "positionsAdmin",
      label: "Positions – Administrative",
      valueType: "count",
      sources: [{ block: "Positions", key: "Administrative" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsTeachers",
      label: "Positions – Teachers",
      valueType: "count",
      sources: [{ block: "Positions", key: "Teachers" }],
      group: "positions",
      defaultVisible: false,
    },

    // SALARIES
    {
      key: "salariesAdmin",
      label: "Salaries – Administrative",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Administrative" },
      ],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesTeachers",
      label: "Salaries – Teachers",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Teachers" },
        { block: "Salaries", key: "Teachers (English)" }, // oddball years
      ],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesTutors",
      label: "Salaries – Tutors",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Tutors" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesMathLabSupv",
      label: "Salaries – Math Lab Supv.",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Math Lab SupV" },
        { block: "Salaries", key: "Math Lab SupV." },
        { block: "Salaries", key: "Math Lab Supv." },
        { block: "Salaries", key: "Math Lab Supv" },
      ],
      group: "salaries",
      defaultVisible: false,
    },

    // 👇 Field Trips still treated as part of salaries section
    {
      key: "fieldTrips",
      label: "Field Trips",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Field Trips" },
        { block: "Salaries", key: "Field Trips (English)" },
        { block: "Supplies / Materials", key: "Field Trips" },
      ],
      group: "salaries",
      defaultVisible: false,
    },

    // SUPPLIES / MATERIALS
    {
      key: "instructionalMaterials",
      label: "Instructional Materials",
      valueType: "currency",
      sources: [
        { block: "Supplies / Materials", key: "Instructional Materials" },
        {
          block: "Supplies / Materials",
          key: "Instructional Materials (English)",
        },
      ],
      group: "materials",
      defaultVisible: false,
    },
    {
      key: "newTextbooks",
      label: "Textbooks",
      valueType: "currency",
      sources: [{ block: "Supplies / Materials", key: "New Textbooks" }],
      group: "materials",
      defaultVisible: false,
    },
    {
      key: "technologySoftware",
      label: "Technology – Software",
      valueType: "currency",
      sources: [
        { block: "Supplies / Materials", key: "Technology Software" },
        { block: "Supplies / Materials", key: "Technology - Software" },
        {
          block: "Supplies / Materials",
          key: "Technology  Software (English)",
        },
      ],
      group: "materials",
      defaultVisible: false,
    },

    // OTHER
    {
      key: "duesFees",
      label: "Dues / Fees",
      valueType: "currency",
      sources: [
        { block: "Other", key: "Dues and Fees" },
        { block: "Other", key: "Dues/Fees" },
        { block: "Other", key: "Dues / Fees" },
      ],
      group: "other",
      defaultVisible: false,
    },
  ],

  tables: [
    {
      id: "approved",
      title: "Approved Budget",
      sectionKey: "Approved",
      fields: [
        "positionsAdmin",
        "positionsTeachers",
        "salariesAdmin",
        "salariesTeachers",
        "salariesTutors",
        "salariesMathLabSupv",
        "fieldTrips",
        "instructionalMaterials",
        "technologySoftware",
        "duesFees",
        "newTextbooks",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsAdmin: { minWidth: "120px" },
        positionsTeachers: { minWidth: "100px" },

        // Salaries
        salariesAdmin: { minWidth: "120px" },
        salariesTeachers: { minWidth: "110px" },
        salariesTutors: { minWidth: "110px" },
        salariesMathLabSupv: { minWidth: "130px" },

        fieldTrips: { minWidth: "90px" },
        instructionalMaterials: { minWidth: "120px" },
        newTextbooks: { minWidth: "80px" },
        technologySoftware: { minWidth: "150px" },
        duesFees: { minWidth: "110px" },
      },
    },
    {
      id: "actual",
      title: "Actual Spending",
      sectionKey: "Actual",
      fields: [
        "positionsAdmin",
        "positionsTeachers",
        "salariesAdmin",
        "salariesTeachers",
        "salariesTutors",
        "salariesMathLabSupv",
        "fieldTrips",
        "instructionalMaterials",
        "technologySoftware",
        "duesFees",
        "newTextbooks",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsAdmin: { minWidth: "120px" },
        positionsTeachers: { minWidth: "100px" },

        // Salaries
        salariesAdmin: { minWidth: "120px" },
        salariesTeachers: { minWidth: "110px" },
        salariesTutors: { minWidth: "110px" },
        salariesMathLabSupv: { minWidth: "130px" },

        fieldTrips: { minWidth: "90px" },
        instructionalMaterials: { minWidth: "120px" },
        newTextbooks: { minWidth: "80px" },
        technologySoftware: { minWidth: "150px" },
        duesFees: { minWidth: "110px" },
      },
    },
  ],
};

export function Program0500(props) {
  return (
    <ProgramBudget programId="0500" config={PROGRAM_0500_CONFIG} {...props} />
  );
}
